/* eslint-disable */
import React from "react";
import HorizontalGraphItem from "./horizontal-graph-item";
import HorizontalGraphLines from "./horizontal-graph-line";
import VerticalGraphItem from "./vertical-graph-item";
import GraphColumn from "./graph-column";
import themePropTypes from "../theme-prop-types";

const GraphWrapper = ({
  graphRef,
  showGrid,
  showColumnName,
  timeLabels,
  verticalSteps,
  graphColumns,
  graphColumnWidth,
  graphColumnHeight,
  calculateBarHeight
}) => {
  return (
    <div
      className='websdk-flex graph-wrapper-web-sdk'
      data-testid='graph-wrapper-web-sdk'
      ref={graphRef}
    >
      <div>
        {showGrid ? (
          <VerticalGraphItem
            top={verticalSteps}
            times={timeLabels}
            canShow={showGrid}
          />
        ) : null}
      </div>
      <div>
        <div className='websdk-flex graph-web-sdk'>
          {showGrid ? (
            <HorizontalGraphLines
              top={verticalSteps}
              times={timeLabels}
              canShow={showGrid}
            />
          ) : null}
          {Object.values(graphColumns).map((value, index) => {
            return (
              <GraphColumn
                width={graphColumnWidth}
                height={graphColumnHeight}
                dayData={value}
                showGrid={showGrid}
                calculateBarHeight={calculateBarHeight}
                key={index}
              />
            );
          })}
        </div>
        <div className='websdk-flex graph-days-web-sdk'>
          {showColumnName
            ? Object.values(graphColumns).map((day, index) => {
                return (
                  <HorizontalGraphItem
                    width={graphColumnWidth}
                    day={
                      graphColumnWidth < 350
                        ? day?.column_name.substring(0, 1)
                        : day?.column_name.substring(0, 3)
                    }
                    canShow={showGrid}
                    key={index}
                  />
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

GraphWrapper.propTypes = themePropTypes.graph;
export default GraphWrapper;
